import React from "react";
import { MainContainer, LoadingContainer } from "./style";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Typography,
  CircularProgress,
} from "@mui/material";
import FieldErrorMessage from "../../../../components/common-components/FieldErrorMessage";
import { CustomTextField } from "../../../../components/common-components/CustomTextField";
import {
  CustomSelect,
  CustomSelectField,
} from "../../../../components/common-components/CustomSelect";
import { CustomPhoneInput } from "../../../../components/common-components/CustomPhoneInput";
import { StyledCircularProgress } from "../../jd-resume/reports/style";
import { useEditUser } from "./useEditUser";

const EditRecruiter = () => {
  const {
    formik,
    roles,
    isLoading,
    isError,
    phomeErrorMessage,
    validatePhoneNumber,
    handleNavigateToList,
    hasChanges,
    isSubmitting,
  } = useEditUser();

  if (isLoading) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }

  if (isError) {
    return <Typography color="error">Error loading recruiter data</Typography>;
  }

  return (
    <MainContainer>
      <Box className="page-card">
        <Box className="page-header">
          <Typography className="page-title">Edit Recruiter</Typography>
          <Typography className="page-subtitle">
            Update the recruiter details below to modify the account
            information.
          </Typography>
        </Box>

        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} className="form-grid">
            <Grid item xs={12} md={6}>
              <Box className="field-block">
                <CustomTextField
                  className="required_field"
                  fullWidth
                  label="Name"
                  placeholder="Enter recruiter name"
                  variant="outlined"
                  id="name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  disabled={isSubmitting}
                />
                <FieldErrorMessage error={formik.errors.name} />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                <CustomTextField
                  className="required_field"
                  fullWidth
                  label="Email"
                  placeholder="Enter email address"
                  variant="outlined"
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  disabled={isSubmitting}
                />
                <FieldErrorMessage error={formik.errors.email} />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                <Box className="custom-phone-input">
                  <CustomPhoneInput
                    country={"us"}
                    value={formik.values.phone}
                    onChange={(phone, country) => {
                      validatePhoneNumber(phone, country);
                    }}
                    inputStyle={{
                      width: "100%",
                    }}
                    inputProps={{
                      name: "phone",
                      id: "phone",
                      autoComplete: "off",
                    }}
                    disabled={isSubmitting}
                  />
                </Box>
                <FieldErrorMessage
                  error={
                    formik.errors.phone ? formik.errors.phone : phomeErrorMessage
                  }
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                <CustomTextField
                  className="required_field"
                  fullWidth
                  label="Title"
                  placeholder="Enter title"
                  variant="outlined"
                  id="title"
                  name="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  disabled={isSubmitting}
                />
                <FieldErrorMessage error={formik.errors.title} />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="field-block">
                <CustomSelect
                  options={roles}
                  getOptionLabel={(option) => option.label}
                  value={
                    roles.find((role) => role.value === formik.values.role) ||
                    null
                  }
                  onChange={(event, value) => {
                    formik.setFieldValue("role", value ? value.value : "");
                  }}
                  disabled={isSubmitting}
                  renderInput={(params) => (
                    <CustomSelectField
                      {...params}
                      label="Role"
                      variant="outlined"
                      error={formik.errors.role}
                    />
                  )}
                  renderOption={(props, option) => (
                    <MenuItem {...props} className="role-menu-item">
                      {option.label || ""}
                    </MenuItem>
                  )}
                />
                <FieldErrorMessage error={formik.errors.role} />
              </Box>
            </Grid>
          </Grid>

          <Box className="form-actions">
            <Button
              className="cancel-btn"
              variant="contained"
              onClick={handleNavigateToList}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            {isSubmitting ? (
              <Button className="btn updating-btn" variant="contained">
                Updating
                <StyledCircularProgress size={18} />
              </Button>
            ) : (
              <Button
                className="btn"
                variant="contained"
                type="submit"
                disabled={!hasChanges}
              >
                Update Information
              </Button>
            )}
          </Box>
        </form>
      </Box>
    </MainContainer>
  );
};

export default EditRecruiter;
